/**
 * Service for managing localStorage operations
 * Handles persistence of critical application state for page refresh scenarios
 */

const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  NAVIGATION_STATE: 'navigationState',
  CURRENT_SUBJECT_ID: 'currentSubjectId',
  CURRENT_SUBJECT_IS_SAMPLE: 'currentSubjectIsSample',
  CURRENT_RESOURCE_ID: 'currentResourceId',
  CURRENT_RESOURCE_DATA: 'currentResourceData'
}

export const StorageService = {
  // Authentication
  setAuthToken(token) {
    if (token) {
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token)
    } else {
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    }
  },

  getAuthToken() {
    return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
  },

  clearAuthToken() {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
  },

  // Navigation State
  saveNavigationState(state) {
    if (state) {
      localStorage.setItem(STORAGE_KEYS.NAVIGATION_STATE, JSON.stringify(state))
    }
  },

  getNavigationState() {
    const state = localStorage.getItem(STORAGE_KEYS.NAVIGATION_STATE)
    return state ? JSON.parse(state) : null
  },

  clearNavigationState() {
    localStorage.removeItem(STORAGE_KEYS.NAVIGATION_STATE)
  },

  // Subject Navigation
  saveSubjectContext(subjectId, isSample) {
    localStorage.setItem(STORAGE_KEYS.CURRENT_SUBJECT_ID, subjectId)
    localStorage.setItem(STORAGE_KEYS.CURRENT_SUBJECT_IS_SAMPLE, JSON.stringify(isSample))
  },

  getSubjectContext() {
    const subjectId = localStorage.getItem(STORAGE_KEYS.CURRENT_SUBJECT_ID)
    const isSample = localStorage.getItem(STORAGE_KEYS.CURRENT_SUBJECT_IS_SAMPLE)
    
    if (subjectId) {
      return {
        subjectId,
        isSample: isSample ? JSON.parse(isSample) : false
      }
    }
    return null
  },

  clearSubjectContext() {
    localStorage.removeItem(STORAGE_KEYS.CURRENT_SUBJECT_ID)
    localStorage.removeItem(STORAGE_KEYS.CURRENT_SUBJECT_IS_SAMPLE)
  },

  // Resource Navigation
  saveResourceContext(resourceData) {
    if (resourceData) {
      try {
        localStorage.setItem(STORAGE_KEYS.CURRENT_RESOURCE_DATA, JSON.stringify(resourceData))
      } catch (e) {
        console.error('Failed to save resource context:', e)
      }
    }
  },

  getResourceContext() {
    try {
      const resourceData = localStorage.getItem(STORAGE_KEYS.CURRENT_RESOURCE_DATA)
      return resourceData ? JSON.parse(resourceData) : null
    } catch (e) {
      console.error('Failed to restore resource context:', e)
      return null
    }
  },

  clearResourceContext() {
    localStorage.removeItem(STORAGE_KEYS.CURRENT_RESOURCE_DATA)
  },

  // Utility
  clearAllSessionData() {
    this.clearAuthToken()
    this.clearNavigationState()
    this.clearSubjectContext()
    this.clearResourceContext()
  }
}

export default StorageService
